var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo39(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 21,
    viewBox: "0 0 291 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21946 19.4165C3.59527 18.5589 2.31962 17.3648 1.3918 15.8336C0.463662 14.3028 0 12.5687 0 10.632C0 8.69525 0.46366 6.96178 1.3918 5.43056C2.31962 3.89973 3.59527 2.70524 5.21946 1.84747C6.84313 0.989714 8.67556 0.561035 10.7173 0.561035C12.4989 0.561035 14.1038 0.874781 15.5331 1.50167C16.9619 2.12896 18.1497 3.0329 19.0962 4.21308L15.5888 7.36728C14.3265 5.855 12.7955 5.09846 10.9956 5.09846C9.93783 5.09846 8.99569 5.32933 8.17011 5.79008C7.34423 6.25142 6.70397 6.9017 6.24943 7.74071C5.79439 8.58032 5.56738 9.54394 5.56738 10.632C5.56738 11.7206 5.79439 12.6842 6.24943 13.5232C6.70397 14.3629 7.34423 15.0129 8.17011 15.4739C8.99569 15.9352 9.93783 16.1655 10.9956 16.1655C12.7955 16.1655 14.3265 15.4093 15.5888 13.8969L19.0962 17.0509C18.1497 18.2317 16.9619 19.1356 15.5331 19.7623C14.1038 20.3892 12.4989 20.7031 10.7173 20.7031C8.67556 20.7031 6.84313 20.2742 5.21946 19.4165Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.267 16.5528H26.0272L24.4961 20.3158H18.873L27.4747 0.948395H32.903L41.5325 20.3158H35.798L34.267 16.5528ZM32.6524 12.5135L30.1471 6.31576L27.6417 12.5135H32.6524Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6313 0.948395V20.3158H57.0939L48.4922 9.99562V20.3158H43.0918V0.948395H47.6292L56.2309 11.2684V0.948395H61.6313Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5833 16.5528H70.3435L68.8126 20.3158H63.1895L71.7912 0.948395H77.2194L85.8489 20.3158H80.1143L78.5833 16.5528ZM76.9688 12.5135L74.4634 6.31576L71.9581 12.5135H76.9688Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4082 0.948395H96.6224C98.7562 0.948395 100.649 1.34522 102.301 2.13805C103.953 2.93129 105.233 4.05662 106.143 5.51345C107.052 6.97087 107.507 8.67712 107.507 10.632C107.507 12.5873 107.052 14.2937 106.143 15.7505C105.233 17.208 103.953 18.3331 102.301 19.1259C100.649 19.9194 98.7562 20.3158 96.6224 20.3158H87.4082V0.948395Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4 0.948395H115.912V20.3158H110.4V0.948395Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.894 16.5528H124.654L123.123 20.3158H117.5L126.102 0.948395H131.53L140.159 20.3158H134.425L132.894 16.5528ZM131.279 12.5135L128.774 6.31576L126.269 12.5135H131.279Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.256 0.948395V20.3158H155.719L147.117 9.99562V20.3158H141.717V0.948395H146.254L154.856 11.2684V0.948395H160.256Z",
    fill: "#E94D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89 1.81987C188.188 2.40078 189.191 3.23092 189.896 4.30988C190.601 5.38903 190.954 6.65733 190.954 8.11415C190.954 9.57158 190.601 10.8352 189.896 11.9047C189.191 12.9746 188.188 13.7999 186.89 14.381C185.591 14.9619 184.059 15.2525 182.297 15.2525H178.9V20.3158H173.389V0.948395H182.297C184.059 0.948395 185.591 1.23875 186.89 1.81987ZM184.524 10.2031C185.099 9.71474 185.386 9.01829 185.386 8.11415C185.386 7.21082 185.099 6.50953 184.524 6.01149C183.948 5.51344 183.094 5.26442 181.962 5.26442H178.9V10.9365H181.962C183.094 10.9365 183.948 10.6921 184.524 10.2031Z",
    fill: "url(#paint0_linear_25_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.145 15.1696H199.139V20.3158H193.627V0.948395H202.535C204.298 0.948395 205.829 1.23875 207.128 1.81987C208.427 2.40078 209.429 3.23092 210.134 4.30988C210.839 5.38903 211.192 6.65733 211.192 8.11415C211.192 9.51613 210.863 10.7385 210.204 11.7803C209.545 12.8226 208.603 13.6388 207.379 14.2288L211.582 20.3158H205.68L202.145 15.1696ZM204.762 6.01149C204.186 5.51344 203.333 5.26442 202.201 5.26442H199.139V10.9365H202.201C203.333 10.9365 204.186 10.6921 204.762 10.2031C205.337 9.71474 205.625 9.01829 205.625 8.11415C205.625 7.21082 205.337 6.50953 204.762 6.01149Z",
    fill: "url(#paint1_linear_25_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.091 0.948395L233.74 20.3158H228.312L219.988 0.948395H225.945L231.234 13.5648L236.635 0.948395H242.091Z",
    fill: "url(#paint2_linear_25_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.23 0.948395H248.742V20.3158H243.23V0.948395Z",
    fill: "url(#paint3_linear_25_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.923 20.122C253.438 19.7346 252.232 19.2185 251.305 18.5726L253.114 14.5332C253.986 15.1051 254.997 15.5664 256.148 15.9165C257.299 16.2671 258.431 16.4423 259.544 16.4423C261.66 16.4423 262.718 15.9165 262.718 14.8651C262.718 14.3118 262.416 13.9015 261.813 13.6339C261.21 13.3668 260.24 13.0853 258.904 12.7901C257.438 12.4767 256.213 12.1398 255.23 11.7803C254.246 11.4206 253.402 10.8443 252.696 10.0511C251.991 9.25823 251.639 8.18814 251.639 6.84161C251.639 5.66123 251.963 4.59619 252.613 3.64587C253.262 2.69616 254.232 1.94426 255.522 1.39097C256.812 0.83768 258.393 0.561035 260.268 0.561035C261.549 0.561035 262.811 0.703995 264.054 0.989714C265.297 1.27604 266.392 1.69524 267.339 2.24873L265.641 6.31574C263.785 5.31986 261.984 4.82182 260.24 4.82182C259.145 4.82182 258.347 4.98353 257.846 5.30595C257.345 5.62897 257.095 6.04858 257.095 6.56476C257.095 7.08136 257.391 7.4689 257.985 7.7268C258.579 7.9855 259.535 8.25266 260.853 8.52931C262.337 8.84306 263.567 9.17939 264.541 9.5391C265.515 9.89882 266.36 10.4707 267.074 11.2546C267.789 12.0388 268.146 13.104 268.146 14.4502C268.146 15.6122 267.821 16.6635 267.172 17.6044C266.522 18.545 265.548 19.2967 264.249 19.8593C262.95 20.4216 261.372 20.7031 259.516 20.7031C257.939 20.7031 256.408 20.5093 254.923 20.122Z",
    fill: "url(#paint4_linear_25_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.734 16.5528H275.494L273.963 20.3158H268.34L276.942 0.948395H282.37L290.999 20.3158H285.265L283.734 16.5528ZM282.119 12.5135L279.614 6.31576L277.109 12.5135H282.119Z",
    fill: "url(#paint5_linear_25_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.565 13.5254L103.953 10.8559L103.252 10.4325C103.132 10.3397 103.007 10.3348 103.079 10.0756L103.73 7.74953L101.867 8.09853C101.559 8.14582 101.461 8.08313 101.39 7.8949L100.99 7.10903L99.5674 8.95241C99.2748 9.26945 98.903 9.07108 98.9694 8.68791L99.7405 4.68294L99.6969 4.71257L99.7039 4.68294L98.8267 5.27804C98.698 5.37462 98.5316 5.4414 98.3698 5.44545C98.2056 5.43958 98.0494 5.36543 97.946 5.18522L96.8168 2.91211L96.7989 2.94805L96.7811 2.91211L95.6519 5.18522C95.5485 5.36543 95.3922 5.43958 95.2281 5.44545C95.0662 5.4414 94.9 5.37462 94.7712 5.27804L93.894 4.68294L93.901 4.71257L93.8573 4.68294L94.6285 8.68791C94.6949 9.07108 94.323 9.26945 94.0305 8.95241L92.6078 7.10903L92.2079 7.8949C92.1369 8.08312 92.0386 8.14582 91.7309 8.09853L89.8675 7.74953L90.5192 10.0756C90.591 10.3348 90.4663 10.3397 90.346 10.4325L89.6445 10.8559L93.0326 13.5254C93.27 13.714 93.2867 13.9562 93.1922 14.2391L92.8603 15.2831L95.9052 14.8469C96.2385 14.7805 96.4018 15.076 96.4018 15.3115L96.3065 18.4947H97.2913L97.196 15.3115C97.196 15.076 97.3593 14.7695 97.6927 14.836L100.738 15.2776L100.406 14.2363C100.311 13.9535 100.328 13.714 100.565 13.5254Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_91",
    x1: 173.389,
    y1: 10.6321,
    x2: 290.999,
    y2: 10.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_91",
    x1: 173.389,
    y1: 10.6321,
    x2: 291,
    y2: 10.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_91",
    x1: 173.389,
    y1: 10.6321,
    x2: 291,
    y2: 10.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_91",
    x1: 173.388,
    y1: 10.6321,
    x2: 290.998,
    y2: 10.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_91",
    x1: 173.39,
    y1: 10.6321,
    x2: 291,
    y2: 10.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_91",
    x1: 173.389,
    y1: 10.6321,
    x2: 290.999,
    y2: 10.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2634"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 20.1421,
    fill: "white",
    transform: "translate(0 0.561035)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo39);
export default __webpack_public_path__ + "static/media/Logo39.2b9475a920fe031b23763cb19970eadd.svg";
export { ForwardRef as ReactComponent };